import React from "react";
import DescriptionAction from "../../Actions/DescriptionAction";
import ReactHtmlParser from 'react-html-parser';
import $ from "jquery";

export default class Description extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.fetchData = this.fetchData.bind(this);


    }

    componentDidMount() {

        if (this.props.queryparams && this.props.queryparams['device'] == "pwa") {
            $("body").css("background", "#000000");
        }
        this.fetchData();

    }
    async fetchData() {
        let timeout = 20000;
        let queryparams = this.props.queryparams;
        // console.log(queryparams);
        if (queryparams) {
            let apiurl = "  ";
            try {
                if (queryparams['islive'] == 1) {
                    apiurl = "https://app-api.editorji.com/";
                }
            } catch (e) {
                apiurl = "https://app-stage.editorji.com/";
            }
            let data = "";
            data = "accessToken=" + queryparams['token'] + "&lang=" + queryparams['lang'];

            await fetch(apiurl + 'live-streaming', {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data
            }).then(res => res.json())
                .then((res) => {
                    try {
                        this.setState({ ...res })
                    } catch (e) {

                    }

                });

        }

        setTimeout(() => {
            this.fetchData();
        }, timeout);

    }


    render() {
        let { device } = this.props.queryparams;

        let data = "";
        if (Object.keys(this.state).length > 0) {
            try {
                data = this.state.data.data;
                data = data['newslist'];
                // console.log(data);
            } catch (e) {

            }


            return (<div className="election_section_main" style={device == "pwa" ? { background: "#000000" } : {}}>
                <section className="election_section">
                    {typeof data == "object" ? Object.keys(data).map((key) => {
                        // console.log(data[key]['video_description'])
                        return (<div><h4 className="election_result_para_new" key={key}>{ReactHtmlParser(data[key]['video_description'])}</h4></div>)
                    }) : <h4 className="election_result_para_new">{this.state.message}</h4>}
                </section>
            </div>)

        } else {
            return null
        }


    }
}
